import { apiClient } from '@/api/client';
import type { PaginatedResult } from '@/types/api';
import type { Alias, AliasListParams } from '@/features/aliases/types';
import type { AliasFormValues } from '@/features/aliases/schema';

export const aliasesApi = {
  list: async (params: AliasListParams): Promise<PaginatedResult<Alias>> =>
    (await apiClient.get<PaginatedResult<Alias>>('/aliases', { params })).data,
  create: async (body: AliasFormValues): Promise<Alias> => (await apiClient.post<Alias>('/aliases', body)).data,
  update: async (id: string, body: Partial<AliasFormValues>): Promise<Alias> => (await apiClient.patch<Alias>(`/aliases/${id}`, body)).data,
  remove: async (id: string): Promise<void> => { await apiClient.delete(`/aliases/${id}`); },
};
